import isEqual from 'hs-lodash/isEqual';
import { useCallback, useRef, useState } from 'react';
import { messages } from '../../../common/messages';
const getInitialPropsMap = ({
  configSpec,
  appliedConfig
}) => Object.keys(appliedConfig).reduce((propsMap, componentName) => {
  const componentDef = configSpec[componentName];
  const appliedComponentDef = appliedConfig[componentName];
  propsMap.set(componentDef, 'initialProps' in appliedComponentDef ? appliedComponentDef.initialProps : {});
  return propsMap;
}, new WeakMap());
const getNameByDef = (apiContext, componentDef) => Object.entries(apiContext.configSpec).find(([__name, def]) => def === componentDef)[0];

/**
 * Utility for managing component props state - to be used only by useCreateNavComponentsManager
 */
export const useComponentPropsManager = apiContext => {
  const initialPropsMap = getInitialPropsMap(apiContext.current);
  const propsMapRef = useRef(initialPropsMap);
  const [__, forceRerender] = useState(0);
  const getComponentProps = useCallback(componentDef => propsMapRef.current.get(componentDef), []);
  const setComponentProps = useCallback((componentDef, props) => {
    const currentComponentProps = propsMapRef.current.get(componentDef);
    const nextProps = typeof props === 'function' ? props(currentComponentProps) : props;
    if (isEqual(currentComponentProps, nextProps)) {
      return;
    }
    const componentName = getNameByDef(apiContext.current, componentDef);
    const context = apiContext.current.iframeContextMap[componentName];
    if (context) {
      context.sendMessage(messages.SET_COMPONENT_PROPS, {
        props: nextProps,
        target: componentName
      });
    }
    propsMapRef.current.set(componentDef, nextProps);
    forceRerender(v => v + 1);
  }, [apiContext]);
  return {
    getComponentProps,
    setComponentProps
  };
};